import { FormEvent, ReactNode, useState } from 'react'
import { Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { APIRequestPost } from '../utils/APIRequests';
import { UserForgotPasswordRequestData } from '../api/User';

function ForgotPassword(): ReactNode {
    const { t } = useTranslation(['forgot_pass', 'base']);

    const [errorInfo, setErrorInfo] = useState<ReactNode>(<div></div>);
    const [enabledButton, setEnabledButton] = useState<boolean>(true);
    const [emailValue, setEmailValue] = useState<string>("");

    function submitForm(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault();
        setEnabledButton(false);

        const data: UserForgotPasswordRequestData = { email: emailValue };

        APIRequestPost(`/user/forgotPassword`, {
            data: data
        }).then(() => {
            setErrorInfo(<div style={{ paddingTop: "10px" }}>{t('success')}</div>);
            setEnabledButton(true);
        }).catch(() => {
            setErrorInfo(<div style={{ color: "red", paddingTop: "10px" }}>{t('error')}</div>);
            setEnabledButton(true);
        });
    }

    return (
        <div className='form-page'>
            <div className='form-page-container'>
                <div className='console-logo'>{t('forgot_pass')}</div>
                <Form onSubmit={submitForm}>
                    <Form.Group className="login-form" controlId={t('address')}>
                        <Form.Label>Адрес</Form.Label>
                        <Form.Control
                            type="email"
                            placeholder={t('address_placeholder')}
                            value={emailValue}
                            onChange={e => setEmailValue(e.currentTarget.value)}
                        />
                        <Form.Text className="text-muted" />
                    </Form.Group>
                    <Button variant="primary" type="submit" disabled={!enabledButton}>
                        {t('submit_button_text')}
                    </Button>
                </Form>
                {errorInfo}
            </div>
        </div>
    )
}

export default ForgotPassword;